// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e07bdb76","455":"c9a58444","977":"ae1d86f2"}[chunkId] + ".chunk.js";
};